import React from 'react';
import SearchPlanet from '../components/search'
import '../assets/login.css'
 const SearchPage =() =>{
 return(
     <SearchPlanet/>
 )
}
export default SearchPage;